import { useContext } from 'react';
import { CollapsibleContext } from '../context';

export const useCollapsible = () => {
  const context = useContext(CollapsibleContext);

  if (context == null) {
    throw new Error('useCollapsible must be inside CollapsibleProvider');
  }

  return context;
};
